import {
    User,
    Users,
    PawPrint,
    Music,
    Zap,
    Mountain,
    Aperture,
} from "lucide-react";

export const NAV_LINKS = [
    { label: "PORTRAITS", hash: "#portraits", testId: "nav-portraits" },
    { label: "FAMILLES", hash: "#familles", testId: "nav-familles" },
    { label: "ANIMAUX", hash: "#animaux", testId: "nav-animaux" },
    { label: "ÉVÉNEMENTS", hash: "#evenements", testId: "nav-evenements" },
    { label: "SPORTS", hash: "#sports", testId: "nav-sports" },
    { label: "NATURE", hash: "#nature", testId: "nav-nature" },
    { label: "STUDIO", hash: "#studio", testId: "nav-studio" },
    { label: "À PROPOS", hash: "#apropos", testId: "nav-apropos" },
];

export const CATEGORIES = [
    {
        id: "portraits",
        number: "01",
        title: "PORTRAITS",
        description: "Portraits en studio ou à l'extérieur.",
        icon: User,
        image: "/photo-portraits.webp",
        alt: "Portrait extérieur d'une femme assise au bord de l'eau — photographie de Daniel Dulude",
        gallery: "VOIR LA GALERIE PORTRAITS",
        galleryUrl:
            "https://danphotographemariage.gallery.aftershoot.com/collection/portraits-et-noir-blanc",
    },
    {
        id: "familles",
        number: "02",
        title: "FAMILLES & COUPLES",
        description: "Des moments naturels et authentiques.",
        icon: Users,
        image: "/photo-familles.webp",
        alt: "Photo de famille en nature sur un sentier — photographie de Daniel Dulude",
        gallery: "VOIR LA GALERIE FAMILLES & COUPLES",
        galleryUrl:
            "https://danphotographemariage.gallery.aftershoot.com/collection/photo-famille",
    },
    {
        id: "animaux",
        number: "03",
        title: "ANIMAUX & CHEVAUX",
        description: "Portraits d'animaux, chevaux et compagnons.",
        icon: PawPrint,
        image: "/photo-animaux.jpg",
        alt: "Deux chevaux dans un pré en automne — photographie de Daniel Dulude",
        gallery: "VOIR LA GALERIE ANIMAUX & CHEVAUX",
        galleryUrl:
            "https://danphotographemariage.gallery.aftershoot.com/collection/animaux-et-chevaux",
    },
    {
        id: "evenements",
        number: "04",
        title: "SPECTACLES & ÉVÉNEMENTS",
        description:
            "Des images qui captent l'énergie, l'émotion et l'ambiance de vos spectacles et événements. Concerts, festivals, spectacles et événements — je capture les moments forts qui méritent d'être revécus.",
        icon: Music,
        image: "/photo-evenements-v2.webp",
        alt: "Chanteur avec chapeau noir et guitare sur scène, batteur en arrière-plan — photographie de Daniel Dulude",
        position: "center 42%",
        gallery: "VOIR LA GALERIE SPECTACLES & ÉVÉNEMENTS",
        galleryUrl:
            "https://danphotographemariage.gallery.aftershoot.com/collection/spectacles-musique",
    },
    {
        id: "sports",
        number: "05",
        title: "SPORTS",
        description:
            "« L'action, la vitesse et l'intensité captées dans chaque image. »",
        icon: Zap,
        image: "/photo-sports.webp",
        alt: "Moto sportive verte la nuit devant un pont illuminé en bleu — photographie de Daniel Dulude",
        gallery: "VOIR LA GALERIE SPORTS",
        galleryUrl:
            "https://danphotographemariage.gallery.aftershoot.com/collection/sports",
    },
    {
        id: "nature",
        number: "06",
        title: "NATURE & PAYSAGES",
        description:
            "Des paysages grandioses, des lumières uniques et des instants qui donnent envie de s'arrêter.",
        icon: Mountain,
        image: "/photo-nature.webp",
        alt: "Coucher de soleil sur la mer et une rivière rocheuse en Gaspésie — photographie de Daniel Dulude",
        position: "center 35%",
        gallery: "VOIR LA GALERIE NATURE & PAYSAGES",
        galleryUrl:
            "https://danphotographemariage.gallery.aftershoot.com/collection/nature-paysages",
    },
    {
        id: "studio",
        number: "07",
        title: "MON STUDIO MAISON",
        description:
            "Un espace chaleureux et créatif où la lumière transforme chaque séance en image unique.",
        icon: Aperture,
        image: "/photo-studio.webp",
        alt: "Daniel Dulude dans son studio maison entouré de ses éclairages professionnels",
        gallery: "VOIR LA GALERIE STUDIO",
        galleryUrl:
            "https://danphotographemariage.gallery.aftershoot.com/collection/studio-maison",
    },
];

export const MARQUEE_ITEMS = [
    "PORTRAITS",
    "FAMILLES & COUPLES",
    "ANIMAUX & CHEVAUX",
    "SPECTACLES & ÉVÉNEMENTS",
    "SPORTS",
    "NATURE & PAYSAGES",
    "MON STUDIO MAISON",
    "13 ANS D'EXPÉRIENCE",
];
